{
  "projectAttributes": {
    "title": "Configurações de atributos",
    "subtitle": "Aqui você pode adicionar e excluir atributos predefinidos que os usuários do seu projeto podem visualizar e usar.",
    "predefined_title": "Atributos predefinidos",
    "predefined_text": "Personalize os atributos predefinidos do seu projeto, que podem ser adicionados às camadas do plano.",
    "no_attributes": "Não há atributos de projeto, crie um usando o botão adicionar atributo acima",
    "active_tab": "Ativo",
    "deprecated_tab": "Inativo",
    "no_deprecated_attributes": "Não há atributos de projeto inativos",
    "deprecate_confirmation_title": "Desativar atributo?",
    "deprecate_confirmation_message": "Esse atributo está em uso e não pode ser excluído. Em vez disso, ele será desativado. Os atributos inativos ficam ocultos ao adicionar atributos às camadas, mas permanecerão nas camadas em que já foram adicionados.",
    "delete_confirmation_title": "Excluir atributo?",
    "delete_confirmation_message": "Tem certeza de que deseja excluir esse atributo? Essa ação não pode ser desfeita.",
    "restore_button": "Restaurar"
  }
}